<template>
  <v-container fluid class="pa-0 ma-0">
    <div v-if="!wrapper" class="hidden-md-and-up">
      <slot name="header-out"></slot>

      <dashboard-content>
        <template slot="header">
          <slot name="header"></slot>
        </template>
        <template slot="first-col">
          <slot name="first-col"></slot>
        </template>
        <template slot="second-col">
          <slot name="second-col"></slot>
        </template>
        <template slot="footer-row">
          <slot name="footer-row"></slot>
        </template>
      </dashboard-content>
      <dashboard-sidebar class="mt-3">
        <slot name="sidebar"></slot>
      </dashboard-sidebar>
    </div>

    <v-layout row wrap class="hidden-sm-and-down pa-3">
      <v-flex md9>
        <og-help-tour v-if="!$store.state.user.skip_tour"></og-help-tour>

        <slot name="header-out"></slot>
        <v-card color="#f2f2f2">
          <dashboard-content>
            <template slot="header">
              <slot name="header"></slot>
            </template>
            <template slot="first-col">
              <slot name="first-col"></slot>
            </template>
            <template slot="second-col">
              <slot name="second-col"></slot>
            </template>
            <template slot="footer-row">
              <slot name="footer-row"></slot>
            </template>
          </dashboard-content>
        </v-card>
      </v-flex>

      <v-flex md3>
        <v-container py-0>
          <dashboard-sidebar>
            <slot name="sidebar"></slot>
          </dashboard-sidebar>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DashboardContent from './sections/DashboardContent';
import DashboardSidebar from './sections/DashboardSidebar';

import OgHelpTour from '@/modules/help/components/OgHelpTour';

export default {
  components: {
    DashboardContent,
    DashboardSidebar,
    OgHelpTour,
  },
  computed: {
    wrapper() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return false;
        case 'sm':
          return false;
        case 'md':
          return false;
        case 'lg':
          return true;
        case 'xl':
          return true;
      }
      return false;
    },
  },
};
</script>
